<div class="snackbar">
    <div class="snackbar-text">
        {{data.message}}
    </div>
    <button class="snackbar-button" (click)="snackBarRef.dismiss()">
        <img class="snackbar-button-icon" src="assets/svgs/close.svg" alt="">
    </button>
</div>
